import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Eye from './icon-eye.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Eye {...validProps} />;
}
SvgComponent.iconName = 'eye';

/**
 * @deprecated This is a legacy icon
 */
export const EyeIcon = svgIconWrapper(SvgComponent);
